import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Stories = () => {
    return (
        <div className='stories'>
            <div className='max-width'>
                <div className='sHead'>
                    Our client sucess Stories
                </div>
                <Container>
                    <Row>
                        <Col>
                            <div className='sCard'>
                                <div className='sCHead'>
                                    <img src='stories.png' alt='' />
                                    <h2>Robert</h2>
                                </div>
                                <div className='sp'>
                                    My career was not growing, 3 yrs in job and I was still earning less than a fresher in Tech.
                                    Joined OneLearn.io and recently got a job in Cars24 after 4 months.
                                    It required hard work but a best decision for my life.
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='sCard'>
                                <div className='sCHead'>
                                    <img src='stories.png' alt='' />
                                    <h2>Robert</h2>
                                </div>
                                <div className='sp'>
                                    Coming from an economics background with ZERO coding knowledge I was not even sure if this can be a career for me.
                                    By chance I saw about OneLearn on LinkedIn and approached Rehan.
                                    Got convinced that even I can do it and now placed in TransOrg Analytics.
                                    Could not have even imagined this can be my career also
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Stories;